import { render, staticRenderFns } from "./MultiSelectInput.vue?vue&type=template&id=cb4d12fc"
import script from "./MultiSelectInput.vue?vue&type=script&lang=js"
export * from "./MultiSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports